import React, { useState } from "react"

// COMPONENTS
import { DropdownIcon, Tag } from "../icons"
import Overlay from "./overlay"

//
import "./styles.scss"
const TabsComponent = ({ sliderData, activeTab, setActiveTab }) => {
  const [dropdown, setDropdown] = useState(false)

  const toggledropdown = () => {
    setDropdown(prev => !prev)
  }

  return (
    <div className="wrapper">
      <Overlay
        className={`dropdown_overlay ${dropdown ? "active" : ""}`}
        onClick={() => setDropdown(false)}
      />

      <div className={`tabs__dd_opener siteFont ${dropdown ? "active" : ""}`}>
        <button className="selected__value" onClick={toggledropdown}>
          <span className="text">{activeTab.replace("_", " ")} </span>
          <span className="dropdown">
            <DropdownIcon />
          </span>
        </button>
      </div>
      <div className={`tabs__div ${dropdown ? "active" : ""}`}>
        {sliderData.map((item, index) => (
          <button
            className={`tab__button ${
              activeTab === item.id ? " tab__button__active" : ""
            }`}
            onClick={() => {
              setActiveTab(item.id)
              toggledropdown()
            }}
            key={index}
          >
            <h5 className="tabs__title siteFont">
              {item.id.replace("_", " ")}
            </h5>
            {item.booked && (
              <div className="hidden tag lg:block">
                <Tag />
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  )
}

export default TabsComponent
